module.exports = __webpack_public_path__ + "static/img/1-1Z52F94443337.1cf9728.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z52F94443337.jpg
// module id = WPr0
// module chunks = 0